import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Inbox, CalendarDays, LogOut, Boxes, Utensils, Settings as SettingsIcon } from "lucide-react";

export default function PartnerLayout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const NavLink = ({ to, label, testid, icon: Icon }) => {
    const active = loc.pathname === to || (to !== "/partner/inbox" && loc.pathname.startsWith(to));
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-medium transition-colors ${
          active ? "bg-ink text-cream" : "text-light-ink hover:bg-cream"
        }`}
      >
        <Icon className="w-4 h-4" strokeWidth={1.6} />
        {label}
      </Link>
    );
  };

  return (
    <div className="min-h-screen flex flex-col bg-off-white text-ink">
      <header className="sticky top-0 z-30 bg-white border-b border-tablo-border">
        <div className="max-w-6xl mx-auto px-5 py-3 flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-6 flex-wrap">
            <Link to="/partner/inbox" className="flex items-center gap-2" data-testid="partner-brand-link">
              <span className="font-serif text-xl text-ink">Tablo</span>
              <span className="text-[10px] uppercase tracking-[0.18em] text-amber font-medium">Partner</span>
            </Link>
            {user && (
              <nav className="flex items-center gap-1 flex-wrap">
                <NavLink to="/partner/inbox" icon={Inbox} label="Inbox" testid="partner-nav-inbox" />
                <NavLink to="/partner/calendar" icon={CalendarDays} label="Calendar" testid="partner-nav-calendar" />
                <NavLink to="/partner/packages" icon={Boxes} label="Packages" testid="partner-nav-packages" />
                <NavLink to="/partner/menu" icon={Utensils} label="Menu" testid="partner-nav-menu" />
                <NavLink to="/partner/settings" icon={SettingsIcon} label="Settings" testid="partner-nav-settings" />
              </nav>
            )}
          </div>
          {user && (
            <button
              onClick={() => { logout(); nav("/partner/auth"); }}
              className="text-sm text-light-ink hover:text-ink flex items-center gap-1"
              data-testid="partner-logout-btn"
            >
              <LogOut className="w-4 h-4" strokeWidth={1.6} /> Logout
            </button>
          )}
        </div>
      </header>
      <main className="flex-1 max-w-6xl w-full mx-auto px-5 py-6">{children}</main>
    </div>
  );
}
